import { VStack } from "@chakra-ui/react";

export default function Container(props: any) {
  return (
    <VStack
      w="100%"
      h="55%"
      spacing={{
        base: "0.2rem",
      }}
    >
      {props.children}
    </VStack>
  );
}
